<img class="thank-you__img" ngSrc="{{assetsUrl}}/Portal/mine-os-black-logo.svg" width="113" height="34" priority>

<h1 class="mine-title-l thank-you__title">{{'common.thankYouPageTitle' | content}}</h1>
    
<a class="thank-you__navigate-text" [routerLink]="userHomePage">{{userHomePageText}}</a>